import { render } from "./ChannelConfig.vue?vue&type=template&id=2d66107c&scoped=true"
import script from "./ChannelConfig.vue?vue&type=script&lang=js"
export * from "./ChannelConfig.vue?vue&type=script&lang=js"

import "./ChannelConfig.vue?vue&type=style&index=0&id=2d66107c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d66107c"]])

export default __exports__